module.exports = __webpack_public_path__ + "img/global-refresh.d749da06.svg";